<template>
  <div class="agent-commission">
    <div class="commission-header">
      <h2>{{ $t('commission_record') }}</h2>
    </div>
    
    <div class="commission-stats">
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalCommission || 0 }}</div>
        <div class="stat-label">{{ $t('total_commission') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.waitCommission || 0 }}</div>
        <div class="stat-label">{{ $t('pending_commission') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalValidBet || 0 }}</div>
        <div class="stat-label">{{ $t('total_valid_bet') }}</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalMembers || 0 }}</div>
        <div class="stat-label">{{ $t('team_members') }}</div>
      </div>
    </div>
    
    <div class="commission-content">
      <div class="commission-list">
        <div class="commission-item" v-for="commission in commissions" :key="commission.id">
          <div class="commission-info">
            <div class="commission-date">{{ commission.created_at || commission.date || '-' }}</div>
            <div class="commission-detail">
              <span>{{ $t('commission_amount') }}: {{ commission.money || commission.amount || 0 }}</span>
              <span>{{ $t('status') }}: {{ commission.state === 1 ? $t('settled') : $t('unsettled') }}</span>
            </div>
          </div>
        </div>
        
        <div class="no-data" v-if="commissions.length === 0 && !loading">
          {{ $t('no_commission_records') }}
        </div>
        
        <!-- 分页 -->
        <div class="pagination" v-if="pagination.total > pagination.pageSize">
          <button class="page-btn" @click="changePage(1)" :disabled="pagination.current === 1">{{ $t('first_page') }}</button>
          <button class="page-btn" @click="changePage(pagination.current - 1)" :disabled="pagination.current === 1">{{ $t('prev_page') }}</button>
          <span class="page-info">{{ $t('page_info', { current: pagination.current, total: pagination.lastPage }) }}</span>
          <button class="page-btn" @click="changePage(pagination.current + 1)" :disabled="pagination.current === pagination.lastPage">{{ $t('next_page') }}</button>
          <button class="page-btn" @click="changePage(pagination.lastPage)" :disabled="pagination.current === pagination.lastPage">{{ $t('last_page') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentCommission',
  data() {
    return {
      loading: false,
      stats: {
        totalCommission: 0,
        waitCommission: 0,
        totalValidBet: 0,
        totalMembers: 0
      },
      commissions: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        lastPage: 1
      }
    };
  },
  created() {
    this.getCommissionStats();
    this.getCommissionList();
  },
  methods: {
    getCommissionStats() {
      var that = this;
      console.log('=== 调用佣金统计接口 /api/team/performance ===');
      this.$apiFun.get('/api/team/performance').then(function(res) {
        console.log('佣金统计数据返回:', res);
        if (res.code === 200 && res.data) {
          that.stats = {
            totalCommission: res.data.total_commission || 0,
            waitCommission: res.data.pending_commission || 0,
            totalValidBet: res.data.total_valid_bet || 0,
            totalMembers: res.data.team_members || 0
          };
        }
      }).catch(function(err) {
        console.error('获取佣金统计错误:', err);
      });
    },
    
    // 获取佣金记录列表（带分页）
    getCommissionList() {
      var that = this;
      that.loading = true;
      
      // 直接拼接URL参数，确保参数正确传递
      var url = '/api/agent/commission/list?page=' + this.pagination.current + '&page_size=' + this.pagination.pageSize;
      console.log('请求URL:', url);
      
      this.$apiFun.get(url).then(function(res) {
        console.log('佣金记录返回:', res);
        if (res.code === 200 && res.data) {
          that.commissions = res.data.data || [];
          that.pagination.total = res.data.total || 0;
          that.pagination.lastPage = res.data.last_page || 1;
          that.pagination.current = res.data.current_page || 1;
        }
        that.loading = false;
      }).catch(function(err) {
        console.error('获取佣金记录失败:', err);
        that.loading = false;
      });
    },
    
    // 切换页码
    changePage(page) {
      if (page < 1 || page > this.pagination.lastPage) return;
      if (page === this.pagination.current) return;
      this.pagination.current = page;
      this.getCommissionList();
    }
  }
};
</script>

<style scoped>
.agent-commission {
  padding: 20px;
  background: #ffffff;
  min-height: 100vh;
}

.commission-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.commission-header h2 {
  margin: 0;
  color: #333;
}

.commission-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.stat-item {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  text-align: center;
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.commission-content {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.commission-list {
  margin-bottom: 20px;
}

.commission-item {
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.commission-item:last-child {
  border-bottom: none;
}

.commission-date {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.commission-detail {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 14px;
  color: #666;
}

.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  gap: 8px;
  flex-wrap: wrap;
}

.page-btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
}

.page-btn:disabled {
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.page-info {
  margin: 0 10px;
  font-size: 14px;
  color: #666;
}

@media (max-width: 768px) {
  .commission-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .commission-stats {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .commission-detail {
    flex-direction: column;
    gap: 5px;
  }
  
  .pagination {
    gap: 5px;
  }
  
  .page-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/agent/agentCommission.vue